<template>
    <div class="topbar-db">
      <a class="mr20" :class="{ active: selectedTab === 'matrix_legal_doc' }" @click="changeContent('matrix_legal_doc')">Matrix Legal Dokumen</a>
      <a class="mr20" :class="{ active: selectedTab === 'dokumen' }" @click="changeContent('dokumen')">Dokumen</a>
      <a class="mr20" :class="{ active: selectedTab === 'badan_usaha' }" @click="changeContent('badan_usaha')">Badan Usaha</a>
      <a class="mr20" :class="{ active: selectedTab === 'perorangan' }" @click="changeContent('perorangan')">Perorangan</a>
    </div>
  </template>
  
<script>
export default {
  data(){
    return{
        selectedTab : 'matrix_legal_doc',
    }
  },
  
  methods: {
      changeContent(content) {
        this.selectedTab = content;
        this.$emit('content-tab', content);
      },
    },
}
</script>